'use client';
import { PropsWithChildren, createContext, useContext, useEffect, useMemo, useState } from 'react';

export type ViewMode = 'desktop' | 'mobile';
type ViewModeStateType = {
    viewMode: ViewMode | undefined;
    setViewMode: (mode: ViewMode) => void;
};

const ViewModeStateContext = createContext<ViewModeStateType>({
    viewMode: undefined,
    setViewMode: () => {},
});

export function ViewModeStateProvider(props: PropsWithChildren) {
    const [viewMode, setViewMode] = useState<ViewMode>();

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setViewMode(window?.innerWidth <= 640 ? 'mobile' : 'desktop');
        }
    }, []);

    const value = useMemo<ViewModeStateType>(
        () => ({
            viewMode,
            setViewMode: (mode: ViewMode) => setViewMode(mode),
        }),
        [viewMode, setViewMode],
    );

    return <ViewModeStateContext.Provider value={value} {...props} />;
}

// a hook which we are going to use whenever we need data from `GlobalStateProvider`
export default function useViewModeState() {
    const context = useContext(ViewModeStateContext);

    if (!context) {
        throw new Error('You need to wrap ViewModeStateProvider.');
    }

    return context;
}
